'use strict';

// クリックイベントを設定
window.addEventListener('DOMContentLoaded', () => {
  //タブのボタンを取得
  const tabButton = document.querySelectorAll(
    '.archiveFaqTabButton'
  ) as NodeListOf<HTMLElement>;

  //　その値に応じて表示するコンテンツを取得
  const tabContents = document.querySelectorAll(
    '.archiveFaq'
  ) as NodeListOf<HTMLElement>;

  // クリックイベント
  tabButton.forEach((el, index) => {
    el.addEventListener('click', () => {
      // タブのボタンのactiveを切り替える
      tabButton.forEach((el) => {
        el.dataset.tab = 'false';
      });
      el.dataset.tab = 'true';

      // タブのコンテンツを切り替える
      tabContents.forEach((el) => {
        el.dataset.tab = 'false';
      });
      tabContents[index].dataset.tab = 'true';
    });
  });
});
